import React, { Component } from "react";
import { Modal, message } from "antd";
import ChangePasswordModalRender from "./children/ChangePasswordModalRender";
import { requsetChangePassword } from "../../../../../../api/apis";
import i18n from "../../../../../../../../locales/i18n";
import { GAPersonalChangePasswordSuccess, GAPersonalChangePasswordFormError } from "../../../../../../ga/personalCenter";

export default class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.forgetFormRef = React.createRef(); // 忘记密码表单ref
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  /**
   * 点击修改密码弹窗提交按钮
   * @param {object} data 表单数据
   */
  handleSubmitChangePassword = data => {
    this.setState({
      changePasswordFormSubmitting: true,
    });
    data.token = this.state.codeToken;
    data.code = this.state.code;
    this.handleRequsetChangePassword(data);
  };

  /**
   *请求修改密码
   * @param {object} data 验证接口参数
   */
  handleRequsetChangePassword = data => {
    let formData = new FormData();
    formData.append("current_password", data.currentPassword);
    formData.append("new_password", data.newPassword);
    formData.append("new_password_confirmation", data.comfirmPassword);
    requsetChangePassword({
      body: formData,
    })
      .then(res => {
        if (res.code === 200) {
          message.success(i18n.t("personalCenterSetting:changePasswordSuccessTips"));
          GAPersonalChangePasswordSuccess();
          this.props.handleVisible(false);
        } else {
          GAPersonalChangePasswordFormError(res.message);
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          changePasswordFormSubmitting: false,
        });
      });
  };

  /**
   *点击忘记密码
   */
  handelForgetPassword = () => {
    this.props.handleVisible(false);
    this.props.handleForgetPasswordModalVisible(true);
  };

  /**
   *新密码input框 onchangge
   * @param {string} e react节点
   */
  handleOnNewPasswordChange = e => {
    /**
     * 监听email值发生变化时，去执行以下confirm email
     */
    console.log(e, this.forgetFormRef);
    if (this.forgetFormRef.current) {
      let confirmPasswordValue = this.forgetFormRef.current.getFieldValue("comfirmPassword");
      if (confirmPasswordValue) {
        this.forgetFormRef.current.validateFields(["comfirmPassword"]);
      }
    }
  };

  render() {
    const { visible, handleVisible } = this.props;
    return (
      <Modal centered maskClosable={false} visible={visible} title={null} footer={null} width={500} onCancel={() => handleVisible(false)}>
        <ChangePasswordModalRender
          email={this.state.email}
          form={this.forgetFormRef}
          submitting={this.state.changePasswordFormSubmitting}
          handleSubmitChangePassword={this.handleSubmitChangePassword}
          handelForgetPassword={this.handelForgetPassword}
          handleOnNewPasswordChange={this.handleOnNewPasswordChange}
        />
      </Modal>
    );
  }
}
